import * as React from 'react';
import Money from '../../Money';
import { useContext } from 'react';
import { CartContext } from '../Cart';
import { BaseButton } from '../../BaseComponents';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../theme';

interface Props {
	onClick: () => void;
}

const Toolbar: React.FC<Props> = ({ onClick }) => {
	const cartContext = useContext(CartContext);

	const { t } = useTranslation('Cart');

	const theme = useTheme('Cart').Toolbar;

	return (
		<div className={theme.container}>
			<div className={theme.money}>
				{cartContext.totalPrices.total.amount > 0 && (
					<>
						<span className={theme.from}>{t('Total')}</span>
						<Money money={cartContext.totalPrices.total} />
					</>
				)}
			</div>

			<BaseButton className={theme.close} variant="action" onClick={onClick}>
				{t('Close')}
			</BaseButton>
		</div>
	);
};

export default Toolbar;
